<app-website-header></app-website-header>
<app-carousel></app-carousel>
  <div class="mx-3 mt-4 breadcrummd-div" style="margin-bottom: 29px;">
    <img class="breadcrumb-icon" src="../../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']"style="cursor:pointer">
    <a class="breadcrummb ps-2" style="color:#0D87C8 ;" [routerLink]="['/']">Home</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
    <a class="breadcrummb" style="color:#0D87C8 ;"*ngIf="profileData && profileData.type === 'brand'"  (click)="brandNavigate()">Brands</a>
    <a class="breadcrummb" style="color:#0D87C8 ;"*ngIf="profileData && profileData.type === 'distributor'"  (click)="distributorNavigate()">Distributor</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
    <a class="breadcrummb" style="color:#0D87C8 ;" *ngIf="profileData && !profileData.companyName">{{selectedTabName}} </a>
    <a class="breadcrummb" style="color:#0D87C8 ;" *ngIf="profileData && profileData.companyName">{{profileData.companyName | titlecase}} / {{selectedTabName}}</a>
  
</div>

  <mat-card class="brand-profile-card">
    <div class="tab-container">
      <div class="tab-header">
        <div class="tab" [class.active]="activeTab === 0" (click)="selectTab(0)">Company Profile </div><span class="d-md-none d-lg-none" >|</span>
        <div *ngIf="profileData && profileData.type === 'brand'" class="tab" [class.active]="activeTab === 1" (click)="selectTab(1)">Products </div><span class="d-md-none d-lg-none" >|</span>
        <div *ngIf="profileData && profileData.type === 'distributor'" class="tab" [class.active]="activeTab === 1" (click)="selectTab(1)">Product Listing </div><span class="d-md-none d-lg-none" >|</span>
       <div *ngIf="profileData && profileData.type === 'brand'" class="tab" [class.active]="activeTab === 2" (click)="selectTab(2)">Catalogs </div><span class="d-md-none d-lg-none" >|</span>
        <div class="tab" [class.active]="activeTab === 3" (click)="selectTab(3)">Exhibitions </div><span class="d-md-none d-lg-none" >|</span>
        <div class="tab" [class.active]="activeTab === 4" (click)="selectTab(4)">Contact Us</div>
        <div class="action-buttons">
          <button class="view-button" (click)="viewProfile()"><img src="assets/images/white-eye.svg" alt="view"/>View</button>
          <button class="download-button" (click)="downloadProfile()"><img src="assets/images/download.svg" alt="Download"/>Download</button>
        </div>
        <div class="tab-slider" [style.width.px]="tabSliderWidth" [style.transform]="'translateX(' + tabSliderPosition + 'px)'"></div>
      </div>

      <div *ngIf="activeTab === 0" class="tab-content" [@slideInOut]>
        <app-company-profile  [data]="profileData" [desc]="desc" ></app-company-profile>
      </div>
      <div *ngIf="activeTab === 1" class="tab-content" [@slideInOut]>
        <app-products [brandProfileProducts]="brandProfileProducts" [data]="profileData"></app-products>
      </div>

      <div *ngIf="activeTab === 2 && profileData.type === 'brand'" class="tab-content" [@slideInOut]>
        <app-catalogs [data]="profileData"></app-catalogs>
      </div>
      <div *ngIf="activeTab === 3" class="tab-content" [@slideInOut]>
        <app-exhibitions [data]="profileData"></app-exhibitions>
      </div>
      <div *ngIf="activeTab === 4" class="tab-content" [@slideInOut]>
        <app-brand-contact-us [data]="profileData"></app-brand-contact-us>
      </div>
    </div>
  </mat-card>

  <app-website-footer></app-website-footer>

<!-- Info to Download and View Profile as pdf-->

<div>
  <div id="companyInfo-page" *ngIf="captureMode" class="company-info-container">
    <div id = 'top-profile-information'>
    <div class="top-section">
      <div class="brand-info-container">
        <div class="brand-info">
          <div style="display: flex;align-items: center; margin-left: 20px;"> 
            <img [src]="profileData.logo" alt="Company Logo" class="company-logo" />
            <div class="company-name-section" style="display: flex; flex-direction: column; align-items: center; margin-left: 20px; ">
              <h1>{{ profileData.companyName }}</h1>
            <ng-container *ngIf="profileData?.url">
              <a target="_blank" href="{{ profileData.url }}">{{ profileData.url }}</a>
            </ng-container>
            </div>
          </div>
        </div>
        <div class="vertical-line"></div>
      </div>

      <div class="address-container">
        <p *ngIf="profileData.address">{{ profileData.address }}</p>
        <p *ngIf="profileData.country || profileData.state || profileData.city || profileData.zipCode">
            {{ profileData.country }}<span *ngIf="profileData.country && (profileData.state || profileData.city || profileData.zipCode)">, </span>
            {{ profileData.state }}<span *ngIf="profileData.state && (profileData.city || profileData.zipCode)">, </span>
            {{ profileData.city }}<span *ngIf="profileData.city && profileData.zipCode">, </span>
            {{ profileData.zipCode }}
        </p>
        <p *ngIf="profileData.email || profileData.phoneCode || profileData.phoneNumber">
            <span *ngIf="profileData.email">{{ profileData.email }}</span>
            <span *ngIf="profileData.email && (profileData.phoneCode || profileData.phoneNumber)">, </span>
            <span *ngIf="profileData.phoneCode">{{ profileData.phoneCode }}</span>
            <span *ngIf="profileData.phoneCode && profileData.phoneNumber">-</span>
            <span *ngIf="profileData.phoneNumber">{{ profileData.phoneNumber }}</span>
        </p>
      </div>
    </div>

    <div *ngIf="profileData.description" class="description-box">
      <h2 class="box-heading">About Company</h2>
      <div class="description-container">
        <div [innerHTML]="profileData.description" class="description-content"></div>
      </div>
    </div>

    <div *ngIf="products.length > 0" class="description-box">
      <h2 class="box-heading">Product Details</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Category</th>
            <th>Certificates</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products">
            <td>{{ product.name }}</td>
            <td>{{ product.categoryName }}</td>
            <td style="cursor: pointer;">
              <span *ngFor="let certificate of product.certificates; let last = last">
                <ng-container *ngIf="certificate.name.length > 0">
                  {{ certificate.name }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="profileData.listBranches && profileData.listBranches.length > 0" class="description-box">
      <h2 class="box-heading">Branches</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Branch Name</th>
            <th>Address</th>
            <th>Contact Person</th>
            <th>Contact Phone</th>
            <th>Contact Email</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let branch of profileData.listBranches">
            <td>{{ branch.brandName }}</td>
            <td>{{ branch.address }}</td>
            <td>{{ branch.contactPerson }}</td>
            <td>{{ branch.contactPhone }}</td>
            <td>{{ branch.contactEmail }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div id="bottom-profile-section" style="padding-top: 20px;">
    <div *ngIf="profileData.listPointOfContact && profileData.listPointOfContact.length > 0" class="description-box">
      <h2 class="box-heading">Point of Contact</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Name</th>
            <th>Position</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Location</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contact of profileData.listPointOfContact">
            <td>{{ contact.employeeName }}</td>
            <td>{{ contact.employeePosition }}</td>
            <td>{{ contact.phone }}</td>
            <td>{{ contact.email }}</td>
            <td>{{ contact.city }}, {{ contact.state }}, {{ contact.country }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="profileData.listFinancialInformation && profileData.listFinancialInformation.length > 0" class="description-box">
      <h2 class="box-heading">Financial Information</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Financial Year</th>
            <th>Net Worth</th>
            <th>Turnover</th>
            <th>Profit</th>
            <th>Growth</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let financial of profileData.listFinancialInformation">
            <td>{{ financial.financialYear }}</td>
            <td>{{ financial.netWorth }}</td>
            <td>{{ financial.turnOver }}</td>
            <td>{{ financial.profit }}</td>
            <td>{{ financial.yearOnYearGrowth }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="profileData && profileData.type === 'brand' && distributorNetwork.length > 0" class="description-box">
      <h2 class="box-heading">Distributor Network</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Distributor Name</th>
            <th>Address</th>
            <th>Email</th>
            <th>Mobile Number</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let distributor of distributorNetwork">
            <td>{{ distributor.distributorName }}</td>
            <td>{{ distributor.address }} {{ distributor.city }}, {{ distributor.country }}</td>
            <td>{{ distributor.email }}</td>
            <td>{{ distributor.phoneNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="profileData && profileData.type === 'distributor' && brands.length > 0" class="description-box">
      <h2 class="box-heading">Connected Brands</h2>
      <table class="table-content">
        <thead>
          <tr>
            <th>Brand Name</th>
            <th>Address</th>
            <th>Email</th>
            <th>Mobile Number</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let brand of brands">
            <td>{{ brand.oemName }}</td>
            <td>{{ brand.address }} {{ brand.city }}, {{ brand.country }}</td>
            <td>{{ brand.email }}</td>
            <td>{{ brand.phoneNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</div>
